export function getExtensionAuthSuccessRedirect(params: {
  pathname: string
  search: string
  isAuthenticated: boolean
  hasResolvedAccount: boolean
}): string | null {
  const { pathname, search, isAuthenticated, hasResolvedAccount } = params
  if (!isAuthenticated || !hasResolvedAccount) return null
  const extensionAuthPaths = new Set([
    '/auth/login',
    '/auth/signup',
    '/auth/extension/login',
    '/auth/extension/signup',
  ])
  if (!extensionAuthPaths.has(pathname)) return null

  const searchParams = new URLSearchParams(search)
  const fromExtensionQuery =
    searchParams.get('from_extension') === 'true' ||
    searchParams.get('from_ce') === 'true' ||
    searchParams.get('source') === 'extension'
  const fromIframe =
    searchParams.get('from_iframe') === 'true' || searchParams.get('embed') === 'iframe'
  const hasExtensionReferrer =
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.referrer === 'string' &&
    document.referrer.startsWith('chrome-extension://')
  const isEmbeddedIframe = typeof window !== 'undefined' && window.parent !== window
  const fromExtension =
    fromExtensionQuery || fromIframe || (isEmbeddedIframe && hasExtensionReferrer)
  if (!fromExtension) return null

  const successParams = new URLSearchParams({
    from_extension: 'true',
    from_ce: 'true',
    source: 'extension',
    from_iframe: fromIframe || isEmbeddedIframe ? 'true' : 'false',
  })
  return `/extension-success?${successParams.toString()}`
}
